export const isExternalChartDefinition = (chartDefinition) => {
    return chartDefinition && 'Data' in chartDefinition;
};
export const isAgChartDefinition = (chartDefinition) => {
    return chartDefinition && 'Model' in chartDefinition;
};
